









import Vue from 'vue';
import Component from 'vue-class-component';
import {Menu} from '@/model/CommonModel';
import ApiUtils from '@/utils/ApiUtils';

@Component
export default class SideMenu extends Vue {
    private readonly menuMapper: any = {
        'MU-HOME': {
            name: 'Home',
            viewName: 'Home',
            claName: 'menu-icon-home',
            iconPath: '/assets/image/icon/menu-home-off.svg'
        },
        'MU-CS': {
            name: 'Case',
            viewName: 'CaseList',
            claName: 'menu-icon-case',
            iconPath: '/assets/image/icon/menu-case-off.svg',
        },
        'MU-CD': {
          name: 'Coding',
          viewName: 'CodingProductList',
          claName: 'menu-icon-coding',
          iconPath: '/assets/image/icon/menu-coding-off.svg'
        },
        'MU-CI': {
            name: 'CaseInfo',
            viewName: 'CaseInfoSenderList',
            claName: 'menu-icon-case-info',
            iconPath: '/assets/image/icon/menu-case-info-off.svg'
        },
        'MU-DT': {
            name: 'Data',
            viewName: 'DataExport',
            claName: 'menu-icon-data',
            iconPath: '/assets/image/icon/menu-data-off.svg'
        },
        'MU-MO': {
            name: 'Monitoring',
            viewName: 'MonitoringDetail',
            claName: 'menu-icon-monitoring',
            iconPath: '/assets/image/icon/menu-monitoring-off.svg',
            menuLabel: `MONITO<br />RING`
        },
        'MU-SM': {
            name: 'Submission',
            viewName: 'SubmissionDetail',
            claName: 'menu-icon-submission',
            iconPath: '/assets/image/icon/menu-submission-off.svg',
            menuLabel: `SUBMI<br />SSION`
        },
        'MU-ES-IL': {
            name: 'Sync',
            viewName: 'SyncStudyList',
            claName: 'menu-icon-sync',
            iconPath: '/assets/image/icon/menu-sync-off.svg'
        },
        'MU-HM-ES': {
            name: 'Sync',
            viewName: 'SyncStudyList',
            claName: 'menu-icon-sync',
            iconPath: '/assets/image/icon/menu-sync-off.svg'
        },
        'MU-AD': {
            name: 'Admin',
            viewName: 'AdminUserList',
            claName: 'menu-icon-admin',
            iconPath: '/assets/image/icon/menu-admin-off.svg'
        },
        'MU-SA': {
            name: 'System',
            viewName: 'CompanyList',
            claName: 'menu-icon-system',
            iconPath: '/assets/image/icon/menu-system-off.svg'
        },
        'AD-MU-NT': {
          name: 'Notice',
          viewName: 'AdminNoticeList',
          claName: 'menu-icon-notice',
          iconPath: '/assets/image/icon/menu-notice-off.svg'
        },
        'AD-MU-CO': {
          name: 'Company',
          viewName: 'AdminCompanyList',
          claName: 'menu-icon-company',
          iconPath: '/assets/image/icon/menu-company-off.svg',
        },
        'AD-MU-SE': {
          name: 'Search',
          viewName: 'AdminSearch',
          claName: 'menu-icon-search',
          iconPath: '/assets/image/icon/menu-search-off.svg'
        },
        'AD-MU-CI': {
          name: 'CaseInfo',
          viewName: 'AdminCaseInfo',
          claName: 'menu-icon-admin-case-info',
          iconPath: '/assets/image/icon/menu-admin-case-info-off.svg'
        },
        'AD-MU-US': {
          name: 'User',
          viewName: 'SystemAdminUserList',
          claName: 'menu-icon-user',
          iconPath: '/assets/image/icon/menu-user-off.svg'
        },
    };

    get menus() {
        const menus: Menu[] = this.$store.getters.menus;

        return menus
            .filter((menu: Menu) => this.menuMapper[menu.menuId])
            .filter((menu: Menu) => menu.menuId !== 'MU-CD' || this.matchAppendix('KR'))
            .map((menu: Menu) => {
                const additional: any = this.menuMapper[menu.menuId];
                const {viewName, iconPath, name, claName, menuLabel} = additional;
                return {
                    ...menu,
                    iconPath,
                    viewName,
                    claName,
                    name,
                    menuLabel: menuLabel ? menuLabel : menu.menuLabel
                };
            });
    }

    get getMenuItemClass() {
        return (menu: any) => {
            return {'menu-is-active': this.$route.meta.depth1 === menu.name};
        };
    }

    public onClick(menu: any) {
        this.$router.push({
            name: menu.viewName,
            params: {
                ...ApiUtils.extractRequiredParams(this.$route.params)
            }
        });
    }

  public matchAppendix(appendix: string): boolean {
    return this.$route.params.appendix === appendix;
  }
}
